import { render } from "./EvidenceTableAccordion.vue?vue&type=template&id=481b1137"
import script from "./EvidenceTableAccordion.vue?vue&type=script&lang=js"
export * from "./EvidenceTableAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__